import React from "react";
import { Text, View } from "react-native";
import * as Fonts from "../../../styles/typography";

export default function LinhaTexto({ navigation }) {
  return (
    <>
      <View style={{ justifyContent: "flex-end" }}>
        <Text
          style={{
            fontSize: Fonts.FONT_SIZE_16,
            textAlign: "center",
            marginTop: 15,
          }}
        >
          Não tem uma conta?{" "}
        </Text>
        <Text
          onPress={() => navigation.navigate("Cadastro")}
          style={{
            fontSize: Fonts.FONT_SIZE_22,
            textAlign: "center",
            marginTop: 1,
            fontWeight: "bold",
          }}
        >
          Cadastre-se
        </Text>

        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            marginTop: 10,
            marginBottom: 10,
          }}
        >
          <View style={{ flex: 1, height: 1, backgroundColor: "black" }} />
          <View>
            <Text style={{ width: 50, textAlign: "center" }}>Ou</Text>
          </View>
          <View style={{ flex: 1, height: 1, backgroundColor: "black" }} />
        </View>
      </View>
    </>
  );
}
